<template>
    <div class="pagination-results">
        Results: <template v-if="itemsTotal">{{ from }}<template v-if="displayTo">...{{ to }}</template> of </template>{{ itemsTotal }}
    </div>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: "PaginationResults",

        computed: {
            ...mapState('pagination', [
                'currentPage',
                'pageSize',
                'itemsTotal',
            ]),

            from() {
                return this.pageSize * (this.currentPage - 1) + 1;
            },

            to() {
                return Math.min(this.from + this.pageSize - 1, this.itemsTotal);
            },

            displayTo() {
                return this.from !== this.to;
            },

        }
    }
</script>

<style scoped>

</style>